import mutations from '@/store/modules/wsm/detail/detail.mutations';
import actions from '@/store/modules/wsm/detail/detail.actions';
import getters from '@/store/modules/wsm/detail/detail.getters';
import { KeyLabel } from '@/store/mutations-typesCommon';

export interface State {
  currentSubType: KeyLabel;
  wsmInstances: KeyLabel[];
  currentWSMInstance: KeyLabel;
}

const initialState: State = {
  currentSubType: { key: '', label: '' },
  wsmInstances: [],
  currentWSMInstance: { key: '', label: '' }
};

export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  actions: actions,
  getters: getters
};
